module.exports = __webpack_public_path__ + "media/05 optimism.f98a0ed5.mp3";